import React, { useContext, useRef, useState } from "react";
import "./guide.css";
import { BsFillBookmarkFill } from "react-icons/bs";
import { FaRegBookmark } from "react-icons/fa";
import { AiOutlineShareAlt } from "react-icons/ai";
import { useParams } from "react-router-dom";
import RatingContext from "../RatingContext";
import { baseUrl } from "../../context/BaseUrl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Courselogo = require("../../images/upsc.png");

const Guide = (props) => {
  const { id } = useParams();
  const { ratingAverage, setRatingAverage } = useContext(RatingContext);
  const BookMarked = async (value) => {
    let val = localStorage.getItem("user");

    if (!val) {
      toast.error("You are not logged in.");
      return;
    }

    val = JSON.parse(val);

    const vid = val.user._id;
    const token = val.token;

    const data = {
      object_id: id,
      user_id: vid,
    };
    const response = await fetch(
      `${baseUrl}/user/user_rights/postbookmark/${vid}`,
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );
    const result = await response.json();

    if (result.code == 500) {
      toast.error(result.msg);
      return;
    }
    toast.success(result.msg);
  };

  return (
    <>
      <div
        className={`guide save-courses-mobile d-md-block ${
          props.dis ? "d-none" : "d-block"
        } ${props.margin ? props.margin : ""}`}
      >
        <div className="row heading pc ">
          <div className={`left col-md-2 ${props.noimg ? "d-none" : ""}`}>
            <img
              src={Courselogo}
              alt="course-img"
              style={{ width: "120px", height: "auto" }}
            />
          </div>
          <div className={`left  ${props.noimg ? "col-md-8" : "col-md-6"}`}>
            <h4>
              {props.name
                ? props.name
                : `UPSC CAPF (AC) 2022 Result Soon : PST/PET Dates, Exam Centre, Syllabus, Exam Pattern & Latest News`}
            </h4>
            <p>
              <span>{props.average}</span> Rating ({props.count})
            </p>
          </div>
          <div className="mt-5 mt-md-0 position-relative right col-md-4">
            <h6 className={` ${props.noimg ? "h-65" : ""}`}>
              <FaRegBookmark
                className="pointer"
                onClick={() => BookMarked(props.id)}
              />
            </h6>
          </div>
          <div className="col-md-12 d-flex left right">
            <span className="pointer pt-2 text-uppercase ">{props.tag[0]}</span>{" "}
            <span className="pointer pt-2 text-uppercase">{props.tag[1]}</span>{" "}
            <span
              className="review pointer pt-2"
              onClick={() => {
                props.link
                  ? props.link.current.scrollIntoView()
                  : console.log("reviewtab not found");
              }}
            >
              Write a review
            </span>
            <button className="ms-auto">Download Guide</button>
          </div>
        </div>
        <div className={`row heading mobile `}>
          <div className="left d-flex justify-content-center align-items-center col-md-1 col-12">
            <img src={Courselogo} alt="course-img" style={{ height: "auto" }} />
            <h4 className="fw-semibold">
              {props.name
                ? props.name
                : `UPSC CAPF (AC) 2022 Result Soon : PST/PET Dates, Exam Centre, Syllabus, Exam Pattern & Latest News`}
            </h4>
          </div>
          <div className="left col-md-7 d-flex ps-md-5 col-12">
            <p>
              <span>{props.average}</span> Rating ({props.count})
            </p>
            <h6 className="ms-auto">
              <FaRegBookmark onClick={() => BookMarked(props.id)} />
            </h6>
          </div>
          <div className="col-12 right text-start  col-md-4">
            <div className="d-flex flex-wrap">
              <button className="disabled" disabled>
                NEET
              </button>{" "}
              <button className="disabled" disabled>
                JEE Main
              </button>{" "}
              <button
                className="review"
                onClick={() => {
                  props.link
                    ? props.link.current.scrollIntoView()
                    : console.log("reviewtab not found");
                }}
              >
                Write a review
              </button>
              <button className="ms-auto">Download Guide</button>
            </div>
            <div></div>
          </div>
        </div>
      </div>

      <div
        className={`guide save-courses-mobile d-md-none ${
          props.dis ? props.dis : "d-none"
        } `}
      >
        <div className="row heading mobile ">
          <div className="left col-md-1 col-11">
            <h4 className="fw-semibold">
              {props.name
                ? props.name
                : `UPSC CAPF (AC) 2022 Result Soon : PST/PET Dates, Exam Centre, Syllabus, Exam Pattern & Latest News`}
            </h4>
            <p>
              <span>{props.average}</span> Rating ({props.count})
            </p>
          </div>
          <div className="left col-md-7 d-flex ps-md-5 col-1">
            <h6 className="ms-auto">
              <BsFillBookmarkFill onClick={() => BookMarked(props.id)} />
            </h6>
          </div>
          <div className="col-12 right text-start  col-md-4">
            <div className="d-flex flex-wrap">
              <button className="disabled disabled-btn " disabled>
                NEET
              </button>{" "}
              <button className="disabled disabled-btn" disabled>
                JEE Main
              </button>{" "}
            </div>
            <div></div>
          </div>
        </div>
      </div>
      {/* guide end*/}
    </>
  );
};

export default Guide;
